export enum UserActionViewDetailIcon {
    Wrench, Trash, Random, Check, Search, Refresh, EyeClose
}
